// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderOnly_wrapper__JoJ6z","container":"HeaderOnly_container__tuQq3"};